import { ApiError } from './http/error';
import { ApiEndpointClient } from './resource-client';
export class MarketAnalysisClient extends ApiEndpointClient {
    constructor(http) {
        super(http, 'valuation-api/v1');
    }
    getMarketAnalysis = async ({ valuationId }, options) => {
        try {
            return await this.get('/valuations/' + valuationId + '/market_analysis', {
                signal: options?.signal,
            });
        }
        catch (error) {
            if (error instanceof ApiError && error.statusCode === 404)
                return null;
            throw error;
        }
    };
    createMarketAnalysis = async ({ valuationId }) => {
        return this.post('/valuations/' + valuationId + '/market_analysis', { json: {} });
    };
}
